<template>
  <form @submit.prevent="save">
    <div class="input-group">
      <input
        type="number"
        class="form-control"
        v-model="cash_voucher_length"
        placeholder="25 (использовать значение по умолчанию)"
        :disabled="loading"
        min="0"
      >
      <span class="input-group-append"><span class="input-group-text" style="font-size: inherit;">см</span></span>
    </div>
    <button
      type="submit"
      v-if="showButton"
      class="btn btn-primary mt-2"
      :class="{loading}"
      :disabled="loading"
    >Сохранить
    </button>
  </form>
</template>
<script>
  import api from '@/api'

  export default {
    name: 'cash-voucher-form',
    props: {
      value: {},
      machine_id: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        cash_voucher_length: this.value ? this.value * 100 : this.value,
        loading: false,
      }
    },
    computed: {
      showButton () {
        return (this.cash_voucher_length || this.value) &&
          // eslint-disable-next-line eqeqeq
          (this.cash_voucher_length != this.value * 100)
      },
    },
    methods: {
      save () {
        // eslint-disable-next-line camelcase
        const cash_voucher_length = this.cash_voucher_length / 100
        this.loading = true
        api
          .post(`machines/${this.machine_id}/cash_voucher`, {cash_voucher_length})
          .then(() => this.$emit('input', this.cash_voucher_length / 100))
          .finally(() => {
            this.loading = false
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cash-voucher-form.vue